import GrowthPlannerSlider from './GrowthPlannerSlider';

export default GrowthPlannerSlider;

export { GrowthPlannerSliderPanel } from './GrowthPlannerSlider';
export type { IGrowthPlannerSliderProps } from './GrowthPlannerSlider';
